import React, { useEffect, useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { Form, Formik } from 'formik'
import { Button, Card, Grid, makeStyles } from '@material-ui/core'
import sponsorshipLevelSlice, {
  getSponsorshipLevelById,
  resetSponsorshipLevel,
  addSponsorshipLevel,
  updateSponsorshipLevel
} from 'store/sponsorship-level'
import { sponsorshipLevelFormSchema } from 'schemas/sponsorshipLevel'
import { toast } from 'react-toastify'
import ViewHeader from 'components/ViewHeader'
import ActionBar from 'components/ActionBar'
import CustomTextField from 'components/Form/CustomTextField'
import ProgressButton from 'components/ProgressButton'
import { Box } from '@mui/material'

const SponsorshipLevelsForm = ({ displayContext, onCloseModal, onSuccess }) => {
  const classes = useStyles()
  const { id } = useParams()
  const history = useHistory()
  const dispatch = useDispatch()
  const { sponsorshipLevel, error } = useSelector((state) => state.sponsorshipLevel)
  const [loading, setLoading] = useState(false)

  let initialValues = {
    category: sponsorshipLevel?.category ?? '',
    categoryLevel: sponsorshipLevel?.categoryLevel ?? ''
  }

  useEffect(() => {
    if (error) {
      const message = error.message
      dispatch(sponsorshipLevelSlice.actions.setError(null))
      toast.error(message)
    }
  }, [error])

  useEffect(() => {
    if (id) dispatch(getSponsorshipLevelById(id))
    return () => dispatch(resetSponsorshipLevel())
  }, [id, dispatch])

  const onSubmit = async ({ category, categoryLevel }) => {
    try {
      setLoading(true)
      const payload = {
        category: category.trim(),
        categoryLevel
      }

      let res, message
      if (id) {
        res = await dispatch(updateSponsorshipLevel(payload, id))
        message = 'Sponsorship level updated successfully'
      } else {
        res = await dispatch(addSponsorshipLevel(payload))
        message = 'Sponsorship level created successfully'
      }

      if (res && displayContext === 'page') {
        toast.success(message)
        goBack()
      }

      displayContext === 'modal' && res && onSuccess && onSuccess(res)
    } catch (err) {
      // do nothing
    } finally {
      setLoading(false)
    }
  }

  const onCancel = () => {
    if (displayContext === 'page') {
      goBack()
    } else {
      onCloseModal()
    }
  }

  const goBack = () => {
    dispatch(resetSponsorshipLevel())
    history.goBack()
  }
  return (
    <Card
      elevation={displayContext === 'page' ? 3 : 0}
      className={displayContext === 'page' ? classes.card : classes.styledCard}>
      {displayContext === 'page' && (
        <ViewHeader title={id ? 'Edit sponsorship level' : 'Create sponsorship level'}>
          <ActionBar actionText="Back" onAction={goBack} />
        </ViewHeader>
      )}
      <Formik
        enableReinitialize
        initialValues={initialValues}
        onSubmit={onSubmit}
        validationSchema={sponsorshipLevelFormSchema}>
        <Form>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <CustomTextField label="Category" name="category" type="text" />
            </Grid>
            <Grid item xs={12} sm={6}>
              <CustomTextField label="Category Level" name="categoryLevel" type="number" />
            </Grid>
          </Grid>
          <Box className={classes.footerButtons}>
            <Button size="large" onClick={onCancel} disabled={loading}>
              Cancel
            </Button>
            <ProgressButton type="submit" label="Save" inProgress={loading} disabled={loading} />
          </Box>
        </Form>
      </Formik>
    </Card>
  )
}

export default SponsorshipLevelsForm

const useStyles = makeStyles({
  footerButtons: {
    marginTop: '1rem',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: '0.75rem'
  },
  card: {
    padding: '24px',
    overflow: 'visible'
  },
  styledCard: {
    paddingTop: '1rem'
  }
})
